import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
    Button,
    Form
} from 'semantic-ui-react';

import history from '#/history';
import { entriesToObject, resolveValidation } from '#/meta';
import rgx from '#/regex';

import { actions } from './sagaSlice';

const validators = {
    email: val => !!val && resolveValidation(val, rgx['email']),
    password: val => !!val && resolveValidation(val, rgx['password'])
};

const semanticErrors = {
    email: {
        content: 'Enter valid email',
        pointing: 'below'
    }
};

const checkErrors = payload => {

    const validations = Object.entries(payload).map(([key, val]) => [key, !validators[key](val)]);

    return entriesToObject(validations);
};

export default connect(state => state.auth, actions)(props => {

    if (props.isSignedIn) {

        history.push('/');
    }

    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState('');

    const isValid = payload => {

        const err = checkErrors(payload);
        setErrors(err);

        return !Object.values(err).includes(true);
    };

    const onSubmit = e => {

        e.preventDefault();

        const payload = { email: email.toLowerCase() };

        if (isValid(payload)) {

            props.requestReset(payload);
        }

    };

    return (
        <Form onSubmit={ onSubmit } loading={ props.isFetching }>

            <h1>Forgot Password?</h1>

            <Form.Field>
                <Form.Input required
                    fluid
                    name='email'
                    type='text'
                    placeholder='Email'
                    label='Email'
                    onChange={e => setEmail(e.target.value)}
                    error={ errors.email ? semanticErrors.email : false}
                />
            </Form.Field>
            <Form.Field>
                <Button type='submit'>Request Password Reset</Button>
            </Form.Field>
            <Link to='/Login'>Login</Link>
        </Form>
    );
});
